import React, { useEffect, useState } from "react";
import SectionTitleAndDescription from "./SectionTitleAndDescription";
import { useDebounce } from "utils";
import AgencyCompanies from "./AgencyCompanies";
import {
  addCandidateWorkCompany,
  addExcludeCompany,
  removeCandidateWorkCompany,
  removeExcludeCompany,
} from "store/slices/searcSlice";
import { useSelector } from "react-redux";
import { RootState } from "store/store";
import AgencyTreeSelecter from "./AgencyTreeSelecter";
import { Divider } from "antd";

interface SelectAgenciesProps {
  industryChangeTrigger?: null | number;
}
const SelectAgencies: React.FC<SelectAgenciesProps> = ({ industryChangeTrigger }) => {
  const industryData = useSelector((state: RootState) => state.search.company);
  const excludedCompanies = useSelector((state: RootState) => state.search.exclude_company);
  const [agencyTypeChangeTrigger, setAgencyTypeChangeTrigger] = useState<null | number>(null);
  const [parentIndustryChangeTrigger, setParentIndustryChangeTrigger] = useState<null | number>(null);

  const onParentAgencyChange = () => {

    parentIndustryChangeTrigger != null ?
      setParentIndustryChangeTrigger(parentIndustryChangeTrigger + 1) :
      setParentIndustryChangeTrigger(0);
  };

  const handelAgencyTypeChange = () => {
    agencyTypeChangeTrigger != null ?
      setAgencyTypeChangeTrigger(agencyTypeChangeTrigger + 1) :
      setAgencyTypeChangeTrigger(0);
  };
  // const [isIncludeCompany, setIsIncludeCompany] = useState(false);
  // const [isExcludeCompany, setIsExcludeCompany] = useState(false);
  // const [totalPages, setTotalPages] = useState(0);
  // const [page, setPage] = useState(1);
  // const [companiesGroup, setCompaniesGroup] = useState<CompanyGroup[]>([]); // Specify type here
  // const [loading, setLoading] = useState(false);

  // const [allIndustries, setAllIndustries] = useState<OptionType[]>([]);

  // const includedCompanies = useSelector((state: RootState) => state.search.company);
  // const excludedCompanies = useSelector((state: RootState) => state.search.exclude_company);

  // const getGroups = async () => {
  //   try {
  //     setLoading(true);
  //     const res = await getCompanyGroups(1, page);

  //     setCompaniesGroup((prevCompaniesGroup) => {
  //       const newGroups = res.results.filter((newGroup: CompanyGroup) => {
  //         return !prevCompaniesGroup.some((existingGroup) => existingGroup.id === newGroup.id);
  //       });
  //       return [...prevCompaniesGroup, ...newGroups];
  //     });

  //     setTotalPages(res.total_pages);
  //     if (page < res.total_pages) {
  //       setPage(page + 1);
  //     }
  //   } catch (error) {
  //     if (error instanceof Error) {
  //       console.error(error.message);
  //     } else {
  //       console.error(String(error));
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const fetchIndustryLeaders = async (query: string) => {
  //   try {
  //     const response = await getIndustryGrpLeaderResult(query);
  //     const data: any = response;
  //     const matches = data?.data?.autocompleteCompanyIndustry?.matches;
  //     setAllIndustries(
  //       matches?.map((item: any) => ({
  //         value: item.company,
  //         label: item.company,
  //       }))
  //     );
  //   } catch (err: any) {
  //     console.error(err);
  //   }
  // };

  // const debouncedSearchSkill = useDebounce((query: string) => {
  //   if (query) {
  //     fetchIndustryLeaders(query);
  //   }
  // }, 500);

  // useEffect(() => {
  //   if (companiesGroup.length === 0) {
  //     getGroups();
  //   }
  // }, []);
  return (
    <>
      <div className="w-1/4">
        <SectionTitleAndDescription
          title="Select Agencies"
          isRequiredSection={false}
          isHelpInfoReq={false}
          description="What agencies do your candidate currently work at?"
        />
      </div>

      <div className="w-3/4">
        <AgencyCompanies
          title="Where do your candidates work?"
          labelTitle="Select Company"
          dispatchAddAction={addCandidateWorkCompany}
          dispatchRemoveAction={removeCandidateWorkCompany}
          industryData={industryData.map((company: any) => company.name)}
        />
        <AgencyCompanies
          title="What companies do your want exclude from search?"
          labelTitle="Select Company"
          dispatchAddAction={addExcludeCompany}
          dispatchRemoveAction={removeExcludeCompany}
          industryData={excludedCompanies}
        />
        <Divider></Divider>
        <AgencyTreeSelecter
          industryChangeTrigger={industryChangeTrigger}
          agencyTypeChangeTrigger={agencyTypeChangeTrigger}
          onParentAgencyChange={onParentAgencyChange}
          parentIndustryChangeTrigger={parentIndustryChangeTrigger}
          handelAgencyTypeChange={handelAgencyTypeChange}
        />
      </div>
    </>
  );
};

export default SelectAgencies;
